import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoPresupuestoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoPresupuestoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getProyectoPresupuestoService(): Observable<
    BodyListResponse<ProyectoPresupuestoDTO>
  > {
    return this.http.get<BodyListResponse<ProyectoPresupuestoDTO>>(
      API_URL + '/api/v1/proyectoPresupuesto/todos',
    );
  }

  guardarProyectoPresupuestoService(
    proyectoPresupuestoDTO: ProyectoPresupuestoDTO,
  ): Observable<BodyResponse<ProyectoPresupuestoDTO>> {
    return this.http.post<BodyResponse<ProyectoPresupuestoDTO>>(
      API_URL + '/api/v1/proyectoPresupuesto',
      proyectoPresupuestoDTO,
    );
  }

  getProyectoPresupuestoPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ProyectoPresupuestoDTO>> {
    return this.http.get<BodyResponse<ProyectoPresupuestoDTO>>(
      API_URL + '/api/v1/proyectoPresupuesto/' + codigo,
    );
  }
}
